import styled from 'styled-components';

export const Container = styled.div`
  @media (max-width: 1200px) {
    align-self: center;
  }

  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
  }
`;
